<template>
  <div>
    <b-form-group :label="$store.state.form.gajiPokok" label-cols-md="3">
      <b-form-select :options="gapok" v-model="dataGaji.masterGajiId" @input="setNominal(dataGaji.masterGajiId)"></b-form-select>
    </b-form-group>
    <b-form-group :label="$store.state.form.nominalGajiPokok" label-cols-md="3">
      <b-form-input :disabled="dataGaji.namaGaji != 'Nego'" type="number" v-model="dataGaji.nominalGaji"></b-form-input>
    </b-form-group>

    <b-alert dismissible fade :show="showing" :variant="variant">
      {{ msg }}
    </b-alert>

    <b-form-group label-cols-md="3">
      <b-button variant="primary" @click="simpan()">
        {{ $store.state.form.simpan }}
      </b-button>
    </b-form-group>
  </div>
</template>

<script>
export default {
  props: ["data", "activeTab"],
  data() {
    return {
      gapok: [
        { value: "", text: "Gapok 1" },
        { value: "", text: "Gapok 2" },
      ],
      dataGaji: {
        masterGajiId: "",
        nominalGaji: 0,
        dataKaryawanId: "",
        namaGaji: "",
      },
      dataGajiKaryawan: null,
      showing: false,
      msg: "",
      variant: "",
    };
  },
  mounted() {},
  watch: {
    data: function (newVar, oldVar) {
      if (newVar != oldVar) {
        if (this.data.statusKerjaKaryawan == 0) {
          this.getGaji();
        }
      }
    },
    activeTab: function (newVar) {
      if (newVar == 1) {
        if (this.data.statusKerjaKaryawan == 0) {
          this.getGaji();
        }
      }
    },
  },
  methods: {
    setNominal(x) {
      this.gapok.forEach((item) => {
        if (item.value == x) {
          this.dataGaji.namaGaji = item.namaGaji;
          if (this.dataGaji.namaGaji == "Nego") {
            this.dataGaji.nominalGaji = this.dataGajiKaryawan.nominalGajiKaryawan;
          } else {
            this.dataGaji.nominalGaji = item.nominalGaji;
          }
        }
      });
    },
    async getGaji() {
      let vm = this;
      let gaji = await vm.$axios.post("masterGaji/list");
      vm.gapok = gaji.data.data.map((item) => {
        let x = item.nominalGaji.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return {
          ...item,
          value: item.masterGajiId,
          text: item.namaGaji + " - " + "Rp. " + x,
        };
      });
      // console.log(gaji.data.data, "iki");
      let gajiKaryawan = await vm.$axios.get("dataKaryawan/detailGajiByKaryawanId/" + vm.$route.query.dataKaryawanId);
      this.dataGajiKaryawan = gajiKaryawan.data.data[0];

      vm.dataGaji.masterGajiId = gajiKaryawan.data.data[0].masterGajiId;
      vm.dataGaji.nominalGaji = gajiKaryawan.data.data[0].nominalGajiKaryawan;
      // console.log(gajiKaryawan.data.data[0].masterGajiId,"dataGaji")
    },
    simpan() {
      let vm = this;
      vm.busy = true;
      vm.button = "Mohon Tunggu";
      vm.dataGaji.dataKaryawanId = vm.data.dataKaryawanId;
      vm.$axios
        .post("dataKaryawan/addGajiKaryawan", vm.dataGaji)
        .then((res) => {
          // console.log(res.data.message);
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$store.commit("set_alert", {
              variant: "success",
              msg: "BERHASIL MENDAFTARKAN GAJI POKOK",
              showing: true,
            });
            // vm.variant = "success";
            // vm.msg = "BERHASIL MENDAFTARKAN GAJI POKOK";
            // vm.showing = true;
            // vm.$emit("change");
            // setTimeout(() => {
            //   vm.showing = false;
            // }, 4000);
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$store.commit("set_alert", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
            // vm.variant = "danger";
            // vm.msg = _.toUpper(res.data.message);
            // vm.showing = true;
            // setTimeout(() => {
            //   vm.showing = false;
            // }, 4000);
          }
        })
        .catch((err) => {
          vm.button = "Simpan";
          vm.busy = false;
          vm.$store.commit("set_alert", {
            variant: "danger",
            msg: err.message.toUpperCase(),
            showing: true,
          });
          // vm.variant = "danger";
          // vm.msg = "TERJADI KESALAHAN PADA SERVER";
          // vm.showing = true;
          // setTimeout(() => {
          //   vm.showing = false;
          // }, 4000);
        });
    },
  },
};
</script>
